export const enUs = {
  translation: {
    floatingButton: {
      suggestion: "suggestion",
      suggestions: "suggestions",
      notification: {
        close: "Close",
        draggable: "Drag",
      },
    },
    sidebar: {
      header: {
        title: "BIA Agents",
        salesTitle: "Sales suggestions",
      },
      tabs: {
        chat: "Chat",
        historico: "History",
        sales: "Sales Agents",
      },
      suggestions: {
        title: "Suggestions based on your order",
        description: "Customers who buy items in your order also tend to buy:",
        loading: "Loading suggestions...",
        empty: "No suggestions available",
        code: "Code",
        addButton: "Add",
        price: "$",
      },
      repeatOrder: {
        title: "Repeat Order",
        empty: "No orders found",
        lastPurchase: "Customer's last purchase on",
        order: "The order",
        orderItems: "contains the following items:",
        selectAll: "Select all",
        totalOrder: "Order total:",
        repeatButton: "Repeat order",
        itemQuantity: "unit(s) |",
        each: "each",
      },
      chat: {
        placeholder: "💬 Chat content will be displayed here",
      },
      history: {
        placeholder: "📋 Order history will be displayed here",
      },
      close: "Close",
    },
    errors: {
      loadSuggestions: "Error loading suggestions:",
      invalidMovementType: "Movement type is not allowed for suggestions:",
      paramsBuildCarrinhoNotInitialized: "paramsBuildCarrinho is not initialized for CART context",
      floatingButtonPosition: "Error loading floating button position:",
      floatingButtonSavePosition: "Error saving floating button position:",
    },
    logs: {
      suggestionsLoaded: "suggestions loaded from API",
    },
  },
};
